import { __rest } from "tslib";
import React from 'react';
import TextButtonWithContextMenu from '../../../Dropdown/Preset/TextButtonWithContextMenu';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import FormElement from '@wix/da-ds/pkg/formControls/layouts/FormElement';
import ArrowDown from '@wix/da-ds/pkg/Icons/24x24/ArrowDown';
var DropdownInput = React.forwardRef(function (_a, ref) {
    var _b;
    var id = _a.id, label = _a.label, isLabelHidden = _a.isLabelHidden, items = _a.items, noBottomSpacing = _a.noBottomSpacing, wrapperClassName = _a.wrapperClassName, value = _a.value, onSelect = _a.onSelect, rest = __rest(_a, ["id", "label", "isLabelHidden", "items", "noBottomSpacing", "wrapperClassName", "value", "onSelect"]);
    var itemsWithSelected = items.map(function (item) {
        return {
            label: item.label || '',
            value: item.value || '',
            selected: item.value === value,
        };
    });
    var selectedItemLabel = ((_b = items.filter(function (item) { return item.value === value; })[0]) === null || _b === void 0 ? void 0 : _b.label) || '';
    return (React.createElement(FormElement, { inputId: id, label: React.createElement(InputLabelText, { isRequired: true }, label), isLabelHidden: isLabelHidden, noBottomSpacing: noBottomSpacing, className: wrapperClassName },
        React.createElement(TextButtonWithContextMenu, { size: "medium", variant: "main", postfixIcon: ArrowDown, items: itemsWithSelected, standardMenuProps: {
                onSelect: onSelect,
            } }, selectedItemLabel)));
});
DropdownInput.displayName = 'DropdownInput';
export default DropdownInput;
//# sourceMappingURL=DropdownInput.js.map